import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { FaInstagram, FaLinkedin, FaTwitter, FaFacebook, FaYoutube } from "react-icons/fa";
import Hero from '../assets/images/const.webp';
const HeroSection = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className="relative w-full h-[60vh] md:h-[70vh] lg:h-[80vh] xl:h-[90vh] 2xl:h-[100vh]">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: Hero ? `url(${Hero})` : '',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50" />
      </div>
      <div ref={ref} className={`relative z-10 flex items-center justify-center h-full px-6 ${inView ? 'opacity-100 transition-opacity duration-1000' : 'opacity-0'}`}>
        <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-white text-center font-bold mt-[-4rem] md:mt-[-5rem] lg:mt-[-6rem] xl:mt-[-7rem]">
          <span>Building Today</span>
          <br />
          For a Sustainable Tomorrow.
        </h1>
      </div>
    </section>
  );
};

const Inquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    contactNumber: "",
    email: "",
    altPhone: "",
    organisation: "",
    query: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://usebasin.com/f/a4f7a8a64e49", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData({
          name: "", contactNumber: "", email: "",
          altPhone: "", organisation: "", query: "",
        });
      } else {
        setStatus("Failed to send message. Try again later.");
      }
    } catch (error) {
      setStatus("Something went wrong.");
    }
  };

  return (
    <div className="flex justify-center items-start min-h-[60vh]">
      <div className="bg-white border border-gray-200 rounded-lg p-6 w-full max-w-4xl shadow-md">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Name:</label>
              <input
                type="text"
                name="name"
                className="w-full p-2 border border-gray-300 rounded-md"
                placeholder="Enter name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Contact Number:</label>
              <input
                type="text"
                name="contactNumber"
                className="w-full p-2 border border-gray-300 rounded-md"
                placeholder="Enter contact no."
                value={formData.contactNumber}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Email Address:</label>
              <input
                type="email"
                name="email"
                className="w-full p-2 border border-gray-300 rounded-md"
                placeholder="Enter email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Alternative Phone:</label>
              <input
                type="tel"
                name="altPhone"
                className="w-full p-2 border border-gray-300 rounded-md"
                placeholder="Enter phone number"
                value={formData.altPhone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Organisation:</label>
            <input
              type="text"
              name="organisation"
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Enter Organisation name"
              value={formData.organisation}
              onChange={handleChange}
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Describe your Query:</label>
            <textarea
              name="query"
              className="w-full p-2 border border-gray-300 rounded-md h-32"
              placeholder="Describe your query here"
              value={formData.query}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="w-full md:w-auto px-6 py-2 bg-[#87212e] text-white rounded-md hover:bg-[#6d1a25] transition-colors">
            Submit
          </button>

          {status && <p className="text-center mt-4 text-sm">{status}</p>}
        </form>
      </div>
    </div>
  );
};

const ContactUs = () => {
  return (
    <div className="px-4 md:px-8 lg:px-16 xl:px-24 2xl:px-32 py-8 md:py-12">
      <h1 className="text-3xl md:text-4xl lg:text-5xl text-center mb-8">Contact Us</h1>
      <h3 className="text-xl md:text-2xl text-[#87212e] mb-4">Offices and Address</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-4 md:p-6 rounded-lg shadow-md">
          <h4 className="text-lg md:text-xl font-medium mb-3">Corporate Office</h4>
          <p className="text-sm md:text-base">
            505, Synergy Tower, Near Vodafone House, Corporate Road, Prahladnagar, Ahmedabad - 380015, Gujarat, India
          </p>
        </div>
        <div className="bg-white p-4 md:p-6 rounded-lg shadow-md">
          <h4 className="text-lg md:text-xl font-medium mb-3">Registered Office</h4>
          <p className="text-sm md:text-base">
            403, Gunjan Tower, Nr. Inorbit Mall, Alembic-Gorwa Rd, Subhanpura, Vadodara, Gujarat 390023
          </p>
        </div>
      </div>
    </div>
  );
};

const Links = () => {
  return (
    <div className="px-4 md:px-8 lg:px-16 xl:px-24 2xl:px-32 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-50 p-6 rounded-lg shadow-md">
          <h3 className="text-2xl md:text-3xl mb-4">@RayInfra</h3>
          <p className="mb-4">Follow us on your favorite channels.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { icon: FaInstagram, name: "Instagram", url: "https://instagram.com" },
              { icon: FaLinkedin, name: "LinkedIn", url: "https://linkedin.com" },
              { icon: FaTwitter, name: "Twitter", url: "https://twitter.com" },
              { icon: FaFacebook, name: "Facebook", url: "https://facebook.com" },
              { icon: FaYoutube, name: "YouTube", url: "https://youtube.com" },
            ].map((platform) => (
              <a
                key={platform.name}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-[#87212e] hover:text-blue-800 transition-colors"
              >
                <platform.icon className="w-5 h-5 mr-2" />
                {platform.name}
              </a>
            ))}
          </div>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg shadow-md">
          <h3 className="text-2xl md:text-3xl mb-4 text-center">Email</h3>
          <p className="text-base md:text-lg">
            If you have any inquiry or need more information please contact us at{' '}
            <strong>info@rayinfra.in</strong>.
          </p>
        </div>
      </div>
    </div>
  );
};

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeroSection />
      <div className="relative z-20 -mt-32 md:-mt-40 lg:-mt-48 w-full">
        <div className="px-4 md:px-8 lg:px-16 xl:px-24 2xl:px-32 w-full">
          <div className="bg-white rounded-[40px] shadow-lg p-6 w-full">
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-center mb-8">Business Inquiry</h2>
            <Inquiry />
          </div>
        </div>
      </div>
      <ContactUs />
      <Links />
    </div>
  );
};

export default ContactPage;